import React from 'react';

export default ({ className, ...other }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.966"
    height="23.423"
    viewBox="0 0 16.966 23.423"
  >
    <path
      d="M79.056,0a8.492,8.492,0,0,0-8.483,8.483c0,5.8,7.591,14.327,7.914,14.687a.764.764,0,0,0,1.137,0c.323-.36,7.914-8.882,7.914-14.687A8.492,8.492,0,0,0,79.056,0Zm0,12.751a4.268,4.268,0,1,1,4.268-4.268A4.273,4.273,0,0,1,79.056,12.751Z"
      transform="translate(-70.573 0)"
      fill="#fff"
    />
  </svg>
);
